import React from "react";
import "../styles/Hero.css";
import HeroImg from '../assets/Hero_Image.png';


const Hero = () => {
  return (
    <section className="hero" id="home">
      <img
        src={HeroImg}
        alt="Hero Background"
        className="hero-img"
        data-aos="zoom-out"
      />
      <div className="hero-overlay" data-aos="fade-up">
        <h1 data-aos="fade-right" data-aos-delay="200">
          Building Businesses, Shaping Futures, Strengthening Communities
        </h1>
        <p data-aos="fade-left" data-aos-delay="400">
           At Venturebiz Promotions Pvt Ltd (VPPL), we connect 
           businesses, communities, and talent through innovation, 
           technology, and sustainable growth.
        </p>
        <div className="hero-cta" data-aos="fade-up" data-aos-delay="600">
          <a href="#contact" className="btn-solid">
            Request a Consultation
          </a>
          <a href="#services" className="btn-outline">
            Explore Our Solutions
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;